import { render, staticRenderFns } from "./TopPage.vue?vue&type=template&id=2635febb&scoped=true&"
import script from "./TopPage.vue?vue&type=script&lang=ts&"
export * from "./TopPage.vue?vue&type=script&lang=ts&"
import style0 from "./TopPage.vue?vue&type=style&index=0&id=2635febb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2635febb",
  null
  
)

export default component.exports